import { Map } from "lucide-react";
import FolderView from "@/components/FolderView";

const FOLDERS = Array.from({ length: 9 }, (_, i) => `Province ${i + 1}`);

export default function National() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
            <Map className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              NATIONAL
            </h1>
            <p className="text-app">Provincial information & documentation</p>
          </div>
        </div>
      </div>

      <FolderView subHub="national" folders={FOLDERS} icon={Map} color="green" />
    </div>
  );
}
